import React from 'react'
import styled from '@emotion/styled'
import cn from 'classnames'
import { themeColorPropOr } from '@groovehq/internal-design-system/lib/util/theme'

const NavItem = styled(({ children, className, active, ...rest }) => {
  return (
    <div className={cn(className, { active })} {...rest}>
      {children}
    </div>
  )
})`
  &&& {
    height: 100%;
    color: ${props => props.theme.color.monochrome.mediumDark};
    cursor: pointer;
    font-size: 13px;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: 1px;
    line-height: 24px;

    &.active {
      color: ${themeColorPropOr('color.primary.brand')};
    }

    &:hover {
      color: ${themeColorPropOr('color.primary.brand')};
    }
  }
`

export default NavItem
